import React from 'react';

export interface AuthTextFieldProps {
  id: string;
  label: string;
  type?: React.HTMLInputTypeAttribute;
  value: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  required?: boolean;
  readOnly?: boolean;
  autoComplete?: string;
  hint?: string;
  error?: string;
}

export function AuthTextField({
  id,
  label,
  type = 'text',
  value,
  onChange,
  placeholder,
  required = false,
  readOnly = false,
  autoComplete,
  hint,
  error,
}: AuthTextFieldProps) {
  return (
    <div className="auth-field">
      <label htmlFor={id} className="auth-field__label">
        {label}
        {required ? <span className="req">*</span> : null}
      </label>
      <input
        type={type}
        id={id}
        className="auth-field__input"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        readOnly={readOnly}
        aria-readonly={readOnly || undefined}
        required={required}
      />
      {hint ? <p className="auth-field__hint">{hint}</p> : null}
      {error ? <p className="auth-field__error">{error}</p> : null}
    </div>
  );
}

export default AuthTextField;
